export default "__VITE_ASSET__CMGS7tTA__";